import { StateSchema } from 'app/config/storeConfig/types';
import { ContractInfo } from '../types';

export const getContractOptions = (state: StateSchema): ContractInfo => state.contractOptions.contractOptions;
